import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckboxIntermediate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M0 4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" />
    <path
      fill="#fff"
      d="M3 8a.9.9 0 0 1 .9-.9h8.2a.9.9 0 1 1 0 1.8H3.9A.9.9 0 0 1 3 8"
    />
  </svg>
);
export default SvgCheckboxIntermediate;
